/**
 * Test IDs for QA automation.
 */
export const testIds = {
  smartLynksTableCancel: "smart-lynks-table-cancel",
  smartLynksTableConfirm: "smart-lynks-table-confirm",
} as const;
